import request from '../../../../request/request';

const getGroupDetails = ({ name }) => {
  return request({
    url: `/webapi/group/${name}/details`
  });
};

const updateDescription = ({ name, description }) => {
  return request({
    url: `/api/groups/${name}`,
    method: 'PUT',
    data: { description }
  });
};

const assignUsers = ({ name, users }) => {
  return request({
    url: `/webapi/group/${name}/assign-users`,
    method: 'POST',
    data: { users }
  });
};

const assignPolicies = ({ name, policies }) => {
  return request({
    url: `/webapi/group/${name}/assign-policies`,
    method: 'POST',
    data: { policies }
  });
};

export { getGroupDetails, updateDescription, assignUsers, assignPolicies };
